"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectInfoFactoryFromJS = exports.ProjectInfoFactory = void 0;
const immutable_1 = require("immutable");
const IExplorerITem_1 = require("./IExplorerITem");
const IProjectFileItem_1 = require("./IProjectFileItem");
exports.ProjectInfoFactory = (0, immutable_1.Record)({
    projectName: null,
    flows: null,
    forms: null,
    projectData: null,
    projectUniqueId: null,
    projectFiles: (0, immutable_1.List)()
});
const ProjectInfoFactoryFromJS = function (data) {
    const projectFiles = data.projectFiles && data.projectFiles.length
        ? data.projectFiles.map(i => (0, IProjectFileItem_1.ProjectFileItemFactoryFromJS)(i))
        : [];
    return (0, exports.ProjectInfoFactory)({
        projectName: data.projectName,
        flows: data.flows ? (0, IExplorerITem_1.ExplorerItemFactoryFromJs)(data.flows) : null,
        forms: data.forms ? (0, IExplorerITem_1.ExplorerItemFactoryFromJs)(data.forms) : null,
        projectData: data.projectData ? (0, IExplorerITem_1.ExplorerItemFactoryFromJs)(data.projectData) : null,
        projectUniqueId: data.projectUniqueId,
        projectFiles: (0, immutable_1.List)(projectFiles),
        packageVersion: data.packageVersion
    });
};
exports.ProjectInfoFactoryFromJS = ProjectInfoFactoryFromJS;
//# sourceMappingURL=IProjectInfo.js.map